export default __webpack_public_path__ + "static/Servicios Adicionales-f9510f0b807a26fe6997925cb4a94b56.svg";